$(document).on('click',function() {
    window.setTimeout(function() {
         $('div[formtype="POPUP"].needsclick .needsclick div[data-testid="form-row"] button[type="button"]').click(function(e){
            e.preventDefault();
            copyToClipboard('.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1.kl-private-quill-wrapper-Lkqws1 .ql-editor p:nth-child(3) strong');
        });
      },100);
});
function copyToClipboard(element) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
}
